import React, { useState } from "react";
import { PlayIcon } from "./icons";

export default function JullySection() {
  const [playing, setPlaying] = useState(false);
  const portrait = "https://customer-assets.emergentagent.com/job_fork-hub-1/artifacts/adauewwj_images.jpg";

  return (
    <section data-testid="jully-section" className="relative py-24 md:py-32 bk-glow">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="bk-card rounded-3xl overflow-hidden p-8 md:p-12">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Bio */}
            <div>
              <span className="text-[11px] uppercase tracking-[0.28em] text-gold/80">
                Featured Endorsement
              </span>
              <h2 className="mt-4 font-display text-4xl md:text-5xl">
                Jully <span className="bk-gold-text italic">Black</span>
              </h2>
              <p className="mt-3 text-gold/90 text-sm uppercase tracking-[0.2em]">
                JUNO Award Winner · Canada’s Walk of Fame · Canada’s Queen of R&amp;B Soul
              </p>
              <p className="mt-6 text-white/70 leading-relaxed">
                Jully Black is a celebrated Canadian singer, songwriter, actor, speaker, and
                cultural icon widely known as Canada’s Queen of R&amp;B Soul. A platinum-selling,
                multiple JUNO Award-winning artist and Canada’s Walk of Fame inductee, Jully has
                built a powerful career through her commanding voice, fearless stage presence,
                and deep commitment to creativity, community, and truth. She has written for and
                collaborated with major artists including Nas, Destiny’s Child, Sean Paul,
                Saukrates, Choclair, and Kardinal Offishall, and has performed alongside global
                stars such as Alicia Keys, Elton John, Celine Dion, Drake, The Black Eyed Peas,
                Kanye West, Bon Jovi, and Jessie Reyez. Beyond music, Jully is also a wellness
                advocate, philanthropist, and keynote speaker whose work continues to inspire
                audiences through messages of resilience, empowerment, and purpose.
              </p>
              <p className="mt-4 text-sm text-white/55">
                <span className="text-gold/80 font-semibold">Known for:</span> Nas · Destiny’s Child · Sean Paul · Alicia Keys · Elton John · Celine Dion · Drake
              </p>
            </div>

            {/* Video */}
            <div>
              <div className="relative rounded-2xl overflow-hidden border border-gold/30 aspect-video">
                {playing ? (
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src="https://www.youtube.com/embed/7mathYHVPDY?autoplay=1&rel=0"
                    title="Testimonial from Jully Black"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <button
                    onClick={() => setPlaying(true)}
                    data-testid="jully-play"
                    className="absolute inset-0 w-full h-full group"
                    aria-label="Play Jully Black testimonial"
                  >
                    <img src={portrait} alt="Jully Black" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="w-20 h-20 rounded-full bk-shimmer flex items-center justify-center text-black shadow-2xl group-hover:scale-110 transition-transform">
                        <PlayIcon className="w-9 h-9 ml-0.5" />
                      </span>
                    </div>
                    <div className="absolute bottom-5 left-5 right-5 text-left">
                      <div className="text-[10px] uppercase tracking-[0.28em] text-gold/90">Testimonial</div>
                      <div className="font-display text-xl md:text-2xl mt-1 text-white">
                        Testimonial from Jully Black
                      </div>
                    </div>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
